import { Link } from 'react-router-dom';
import { Button } from './Button';

interface Props {
  hasPremium: boolean;
  stars: number;
  strikethrough?: number;
  badge?: string | null;
  closed?: boolean;
}

export function GoldenTicketCard({ hasPremium, stars, strikethrough, badge, closed }: Props) {
  if (hasPremium) {
    return (
      <div className="rounded-2xl border-2 border-trophy-gold/60 bg-bg-card p-5 shadow-gold-glow">
        <div className="flex items-center justify-between">
          <div>
            <div className="font-display-alt text-xs uppercase tracking-widest text-trophy-gold">
              Bracket Premium
            </div>
            <div className="font-chunky text-xl text-text-base mt-1">You're in. ✨</div>
          </div>
          <Link
            to="/bracket"
            className="rounded-lg bg-trophy-gold px-4 py-2 font-chunky text-sm uppercase text-bg-night"
          >
            View
          </Link>
        </div>
      </div>
    );
  }

  if (closed) {
    return (
      <div className="rounded-2xl border-2 border-border-base bg-bg-card p-5 opacity-80">
        <div className="font-display-alt text-xs uppercase tracking-widest text-text-faint">
          Bracket Premium
        </div>
        <div className="font-chunky text-xl text-text-base mt-1">Closed — picks locked.</div>
        <div className="text-sm text-text-dim mt-2">Free predictions still open below.</div>
      </div>
    );
  }

  return (
    <div className="programme-stripe relative rounded-2xl border-2 border-trophy-gold/40 bg-bg-card p-5 shadow-gold-glow">
      {badge && (
        <div className="absolute -top-3 right-4 rounded-full bg-trophy-gold px-3 py-1 font-chunky text-[10px] uppercase tracking-wider text-bg-night">
          {badge}
        </div>
      )}
      <div className="font-display-alt text-xs uppercase tracking-widest text-trophy-gold">
        Bracket Premium
      </div>
      <div className="font-display text-3xl uppercase text-text-base mt-1 leading-tight">
        Predict the
        <br />
        whole tournament
      </div>
      <div className="text-sm text-text-dim mt-3 leading-relaxed">
        Lock all 12 groups, the full knockout bracket, champion and Golden Boot. Locks 23:59 UTC on 10 Jun.
      </div>

      <div className="mt-5 flex items-end gap-2">
        <span className="font-display text-5xl text-trophy-gold leading-none">{stars}</span>
        <span className="font-display-alt text-xl text-text-dim mb-1">⭐</span>
        {strikethrough && (
          <span className="font-mono text-base text-text-faint line-through ml-2 mb-1">
            {strikethrough}
          </span>
        )}
      </div>

      <Link to="/bracket" className="mt-4 block">
        <Button variant="gold" fullWidth>
          Enter the bracket
        </Button>
      </Link>
    </div>
  );
}
